var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 216 318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M7 0h226a7 7 0 0 1 7 7v125a7 7 0 0 1-7 7H7a7 7 0 0 1-7-7V7a7 7 0 0 1 7-7z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "150.4%",
    height: "187.1%",
    x: "-25.2%",
    y: "-40.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.21446132 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 156.75 122.25)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    transform: "rotate(-90 196.25 64.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.75,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.821,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.893,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.964,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.583,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.655,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.726,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.798,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.417,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.488,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.56,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.631,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.25,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.321,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.393,
    cy: 2.75,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.464,
    cy: 2.75,
    r: 2.75
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1775C1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.926 77.9v-7.528h7.555V77.9zM52.926 68.22v-7.528h7.555v7.529zM72.322 68.674v-8.071H80.5v8.071zM72.322 78.988v-7.623H80.5v7.623zM72.322 89.75v-8.071H80.5v8.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.643 80.32l9.966.001.001-19.629 7.41-.003V80.32h.002V90H52.643v-9.68z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.612b6a6a.svg";
export { ForwardRef as ReactComponent };